<template>
  <li class="hotelPlanItem">
    <tk-link href="javascript:void(0)" @click.prevent="$emit('plan-selected')">
      <h3 class="hotelPlanName">{{ name }}</h3>
      <p v-if="promotion" class="hotelPlanPromotion">{{ promotion }}</p>
      <div class="hotelPlanItemBox mt10">
        <div class="hotelPlanInfo">
          <p v-if="showRefundInfo" class="cancelDeadline">
            {{
              refundable
                ? `${cancelDate}まで、キャンセル料無料`
                : 'キャンセル不可'
            }}
          </p>
          <p class="mealFlag">
            <tk-svg-icon class="icoMeal" icon="meal" />
            {{ mealInfo || '食事無し' }}
          </p>
        </div>
        <div class="hotelPlanPrice">
          <p class="totalPrice">
            <span class="fontNo">{{ price }}</span
            >円
            <span class="nights">（1名あたりの料金）</span>
          </p>
          <p v-if="discount" class="specialPrice">セット割で{{ discount }}円</p>
        </div>
        <p aria-label="プランを選択" class="hotelBtn">
          プランを選択
        </p>
      </div>
    </tk-link>
  </li>
</template>

<script>
import TkSvgIcon from '../../atoms/TkIcon/TkSvgIcon.vue'
import TkLink from '../../atoms/TkLink/TkLink.vue'

export default {
  name: 'TkHotelPlanItem',
  components: {
    TkSvgIcon,
    TkLink,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    cancelDate: {
      type: String,
      default: '',
    },
    mealInfo: {
      type: String,
      default: '',
    },
    discount: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      required: true,
    },
    personCount: {
      type: Number,
      required: true,
    },
    stayDay: {
      type: Number,
      required: true,
    },
    refundable: {
      type: Boolean,
      default: false,
    },
    showRefundInfo: {
      type: Boolean,
      default: false,
    },
    promotion: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@ota-frontend/ui/src/scss/components/TkHotelPlanItem.scss';
</style>
